// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"320":"ucare-panel-chunk","512":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"320":"4bea9bca","376":"c8656616","512":"f04270a8","592":"a3049a16"}[chunkId] + ".chunk.js";
};